exports.cs = {
  TRANSPARENT_ACCOUNT: {
    SEARCH: {
      TITLE: 'Transparentní účty',
      PLACEHOLDER: 'Hledejte podle jména nebo čísla účtu',
      NO_RESULTS: 'Pro zadané jméno nebo číslo účtu nebylo nic nalezeno',
      ERROR_BACKEND: 'Omlouváme se, ale aplikace je momentálně nedostupná. Kontaktujte nás na bezplatné lince 800 207 207.'
    },
    ACCOUNTS_TABLE: {
      OWNER: 'Majitel účtu',
      NUMBER: 'Číslo účtu'
    },
    RESULTS: {
      TITLE: 'Transparentní účet',
      BACK_TO_SEARCH: 'Zpět na přehled',
      NO_RESULTS: 'Transparentní účet nebyl nalezen',
      ACCOUNT_NUMBER: 'Transparentní účet',
      ACCOUNT_OWNER: 'Majitel transparentního účtu',
      ACCOUNT_BALANCE: 'Celkový zůstatek na běžném účtu',
      ACCOUNT_DESCRIPTION: 'Popis',
      ACCOUNT_TRANSACTIONS: {
        TITLE: 'Pohyby na účtu',
        FROM: 'Transakce od',
        TO: 'Transakce do',
        SEARCH: 'Vyhledat',
        SEARCH_PLACEHOLDER: 'Název, poznámka, variabilní symbol, konstantní symbol',
        FILTER_SET: 'Filtrovat',
        FILTER_RESET: 'Zrušit filtr'
      },
      CURRENCY: 'Valuta',
      FOUND_COUNT: 'Nalezena %{smart_count} položka |||| Nalezeny %{smart_count} položky |||| Nalezeno %{smart_count} položek',
      VISIBLE_COUNT: 'zobrazuje se %{smart_count} položka |||| zobrazují se %{smart_count} položky |||| zobrazuje se %{smart_count} položek',
      HISTORY: {
        TITLE: 'Historie transakcí',
        DOWNLOAD_ERROR: 'Ke stažení souboru nemáte oprávnění.'
      }
    }
  },
  DATE: 'Datum',
  TYPE: 'Typ',
  ACCOUNT_NAME: 'Název účtu',
  ACCOUNT_NUMBER: 'Číslo účtu',
  DESCRIPTION: 'Poznámka',
  AMOUNT: 'Částka',
  SHOW_MORE: 'Zobrazit více',
  VARIABLE_SYMBOL: 'Variabilní symbol',
  CONSTANT_SYMBOL: 'Konstantní symbol',
  SPECIFIC_SYMBOL: 'Specifický symbol',
  CZK: 'Kč'
}
